import api from 'api';

export const loadInfluencers = api('GET /api/influencers/grid');

export const loadInfluencerDetails = api('GET /api/influencers/:id/details');

export const createInfluencer = api('POST /api/influencers');

export const updateInfluencer = api('PUT /api/influencers/:id');

export const deleteInfluencer = api('POST /api/influencers/:id/delete');
